import {
  Button,
  Card,
  CardBody,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@apollo/orbit';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getOnboardingVariant } from 'src/lib/analytics/amplitude/helpers/getOnboardingVariant';
import { ampli } from 'src/lib/analytics/amplitude/vendor';
import Config from 'src/lib/config';
import { useGrowthShowRoverCTA } from 'src/lib/featureFlags';
import { setOverlayVisibleLocation } from 'src/lib/routing';

export const GraphQLCallToAction = ({
  planName,
}: {
  planName: string | undefined;
}) => {
  const location = useLocation();
  const history = useHistory();
  const shouldShowRoverCTA = useGrowthShowRoverCTA();
  return (
    <Card>
      <CardHeader>
        <CardTitle size="lg" as="h4">
          I have a GraphQL API
        </CardTitle>
        <CardDescription>
          Get started with GraphOS by publishing your existing graph.
        </CardDescription>
      </CardHeader>
      <CardBody className="flex flex-grow flex-col justify-end">
        <Button
          size="md"
          className="size-full whitespace-normal sm:h-auto sm:w-fit"
          variant={shouldShowRoverCTA ? 'primary' : 'secondary'}
          onClick={async () => {
            ampli.connectGraphFlowStarted({
              'API Type': 'GraphQL',
              OnboardingVariant: getOnboardingVariant(planName),
            });

            history.push(
              setOverlayVisibleLocation({
                location,
                overlayName: Config.modals.createGraph,
              }),
            );
          }}
        >
          Connect a GraphQL API
        </Button>
      </CardBody>
    </Card>
  );
};
